import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The card network to determine the length of the field for CVV validation.`}</p>
    <p>{`You should pass the `}<inlineCode parentName="p">{`paymentInstrumentData.network`}</inlineCode>{` attribute on any of the `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/primer-headless-checkout/vaultedPaymentMethod"
      }}>{`VaultedPaymentMethod`}</a>{`s returned by `}<a parentName="p" {...{
        "href": "#headlessvaultmanager.deleteVaultedPaymentMethod"
      }}>{`fetchVaultedPaymentMethods`}</a>{`.`}</p>
    <p>{`If you don't pass a `}<inlineCode parentName="p">{`cardNetwork`}</inlineCode>{` or the SDK cannot recognize the card network passed in, it will raise a warning and will default the validation of the CVV to a minimum length of 3 and a maximum length of 4.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      